export const SCROLLBAR_WIDTH = 0.5;
export const SCROLLBAR_HEIGHT = 0.5;
